import React from 'react';
import { Sparkles, ArrowRight, CheckCircle2 } from 'lucide-react';
import { HeroIllustration } from './HeroIllustration';
export function Hero() {
  return <section className="relative min-h-[calc(100vh-4rem)] bg-slate-950 overflow-hidden flex items-center pt-12 pb-24 lg:pt-0 lg:pb-0" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-137">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-138">
          {/* Left Column - Content */}
          <div className="lg:col-span-7 flex flex-col items-start z-10" data-id="element-139">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/50 text-indigo-300 text-sm font-medium mb-8 animate-fade-in-up" data-id="element-140">
              <span className="text-indigo-400" data-id="element-141">✦</span>
              AI-native · Powered by MCP
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight text-slate-100 mb-6 leading-[1.1] animate-fade-in-up delay-100" data-id="element-142">
              Orchestrate work.
              <br data-id="element-143" />
              Your tools,{' '}
              <span className="bg-gradient-to-r from-indigo-500 to-sky-400 bg-clip-text text-transparent" data-id="element-144">
                amplified by AI.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-400 max-w-xl mb-10 animate-fade-in-up delay-200 leading-relaxed" data-id="element-145">
              Workium AI connects Jira, Slack, Confluence, and Notion through an
              AI Scrum Master that reads, reasons, and acts — in real time,
              across your entire stack.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-8 animate-fade-in-up delay-300" data-id="element-146">
              <a href="#demo" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-indigo-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-indigo-500 transition-all hover:shadow-[0_0_30px_-5px_rgba(99,102,241,0.5)]" data-id="element-147">
                <Sparkles className="w-5 h-5" data-id="element-148" />
                Join the Wishlist
              </a>
              <a href="#demo" className="w-full sm:w-auto group flex items-center justify-center gap-2 bg-transparent border border-slate-700 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:border-slate-500 hover:bg-slate-800/50 transition-all" data-id="element-149">
                Request a Demo
                <ArrowRight className="w-5 h-5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-150" />
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-500 animate-fade-in-up delay-500" data-id="element-151">
              <div className="flex items-center gap-1.5" data-id="element-152">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-153" />
                <span data-id="element-154">No credit card required</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-155">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-156" />
                <span data-id="element-157">Works with your existing tools</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-158">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-159" />
                <span data-id="element-160">Ready in minutes</span>
              </div>
            </div>
          </div>

          {/* Right Column - Illustration */}
          <div className="lg:col-span-5 relative animate-fade-in-up delay-300" data-id="element-161">
            <HeroIllustration data-id="element-162" />
          </div>
        </div>
      </div>
    </section>;
}